import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TotemService } from '../totem.service';

@Component({
  selector: 'app-mi-ubicacion',
  templateUrl: './mi-ubicacion.component.html',
  styleUrls: ['./mi-ubicacion.component.css']
})
export class MiUbicacionComponent implements OnInit {
  // planos: Array<any>;
  // piso: any;

  // constructor(private totemService: TotemService) { }

  // ngOnInit() {
  //   this.obtenerPlanos();
  // }
  
  // async obtenerPlanos() {
  //   await this.totemService.getTotemConfig();
  //   this.planos = await this.totemService.getPlanos().toPromise();
  // }
  
  planos = [];
  menuIn = false;
  totemConfig;
  pisito;
  opcion = 'tiendas';
  idEst = 0;
  rutaalt = false;

  constructor(private totemService: TotemService,
              private activeRoute: ActivatedRoute, private router: Router ) {
    router.events.subscribe((val) => {
      const routeParams = this.activeRoute.snapshot.params;
      this.opcion = routeParams.opt;
      if (this.opcion === 'estacionamiento') {
        this.idEst = routeParams.piid;
      }
      console.log('this.opcion', this.opcion);
    });
   }

  async ngOnInit() {
    // this.totemConfig = await this.totemService.getTotemConfig();
    const result = await this.totemService.getPlanos().toPromise();
    console.log('result', result);
    this.planos = result.map(piso => {
      piso.siglapiso = this.calcSiglaPiso(piso.piso_numero);
      return piso;
    });
    console.log('planos', this.planos);
  }
  desplegarInstrucciones() {
    this.menuIn = !this.menuIn;
    const manage = !this.menuIn ? 'show' : 'hide';
  }
  calcSiglaPiso(piso: number) {
    return piso >= 0 ? `p${piso.toString()}` : `b${Math.abs(piso).toString()}`;
  }
  obtenerEstacionamiento() {
    const estNombre = this.totemService.getEstacionamientoPorID(Number(this.idEst));
    return estNombre;
  }
}
